// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity_button_group{
    --tw-border-opacity: 1;
    border-color: rgb(230 230 230);
    border-width: 1px;
    border-radius: .375rem;
    overflow: hidden;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    height: 2.75rem;
    display: flex;
    background-color: rgb(255 255 255/var(--tw-bg-opacity));
    /* background-color: rgb(221, 220, 220); */
}

.quantity_button{
    /* border-inline-end-width: 1px; */
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    transition-duration: .3s;
    --tw-border-opacity: 1;
    border-color: rgb(221, 220, 220/var(--tw-border-opacity));
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 2.5rem;
    height: 100%;
    display: flex;
    border: 0 solid #f9f9f9;
    /* background-color: #c8cccc; */
}
.quantity_button:hover{
    --tw-text-opacity: 1;
    color: rgb(255 255 255/var(--tw-text-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(3, 137, 163);
    /* background-color: rgb(3, 137, 163); */
}

.quantity_value{
    width: 3rem;
    /* padding: 0; */
    padding-left: 0 !important;
}
   
@media screen and (max-width: 768px) {
    .mobile_cart_btn_group{
        width: 26%;
    }
    .mobile_cart_btn{
        width: 2rem;
    }
  }
  @media screen and (max-width: 426px) {
    .mobile_cart_btn_group{
        width: 46%;
        float: right;
    }
    .mobile_cart_btn{
        width: 1.9rem;
        height: 66%;
        border-radius: 24%;
    }
    .remove-cart-button-mobile{
        text-align: end !important;
    }
  }
  @media screen and (max-width: 376px) {
    .mobile_cart_btn_group{
        width: 50.5%;
    }
    .mobile_cart_btn{
        width: 1.9rem;
    }
  }

  @media screen and (max-width: 320px) {
    .mobile_cart_btn_group{
        width: 54.5%;
    }
    .mobile_cart_btn{
        width: 1.9rem;
    }
  }

  .cart_products{
    border-bottom: 1px solid #dddddd;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .mobile_cart_product_name{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  `, "",{"version":3,"sources":["webpack://./src/assets/Css/cart.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,aAAa;IACb,uDAAuD;IACvD,0CAA0C;AAC9C;;AAEA;IACI,kCAAkC;IAClC,mDAAmD;IACnD,wBAAwB;IACxB,sBAAsB;IACtB,yDAAyD;IACzD,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,+BAA+B;AACnC;AACA;IACI,oBAAoB;IACpB,8CAA8C;IAC9C,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;EACF;EACA;IACE;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,0BAA0B;IAC9B;EACF;EACA;IACE;QACI,YAAY;IAChB;IACA;QACI,aAAa;IACjB;EACF;;EAEA;IACE;QACI,YAAY;IAChB;IACA;QACI,aAAa;IACjB;EACF;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB","sourcesContent":[".quantity_button_group{\n    --tw-border-opacity: 1;\n    border-color: rgb(230 230 230);\n    border-width: 1px;\n    border-radius: .375rem;\n    overflow: hidden;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n    height: 2.75rem;\n    display: flex;\n    background-color: rgb(255 255 255/var(--tw-bg-opacity));\n    /* background-color: rgb(221, 220, 220); */\n}\n\n.quantity_button{\n    /* border-inline-end-width: 1px; */\n    transition-timing-function: cubic-bezier(.4,0,.2,1);\n    transition-duration: .3s;\n    --tw-border-opacity: 1;\n    border-color: rgb(221, 220, 220/var(--tw-border-opacity));\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    width: 2.5rem;\n    height: 100%;\n    display: flex;\n    border: 0 solid #f9f9f9;\n    /* background-color: #c8cccc; */\n}\n.quantity_button:hover{\n    --tw-text-opacity: 1;\n    color: rgb(255 255 255/var(--tw-text-opacity));\n    --tw-bg-opacity: 1;\n    background-color: rgb(3, 137, 163);\n    /* background-color: rgb(3, 137, 163); */\n}\n\n.quantity_value{\n    width: 3rem;\n    /* padding: 0; */\n    padding-left: 0 !important;\n}\n   \n@media screen and (max-width: 768px) {\n    .mobile_cart_btn_group{\n        width: 26%;\n    }\n    .mobile_cart_btn{\n        width: 2rem;\n    }\n  }\n  @media screen and (max-width: 426px) {\n    .mobile_cart_btn_group{\n        width: 46%;\n        float: right;\n    }\n    .mobile_cart_btn{\n        width: 1.9rem;\n        height: 66%;\n        border-radius: 24%;\n    }\n    .remove-cart-button-mobile{\n        text-align: end !important;\n    }\n  }\n  @media screen and (max-width: 376px) {\n    .mobile_cart_btn_group{\n        width: 50.5%;\n    }\n    .mobile_cart_btn{\n        width: 1.9rem;\n    }\n  }\n\n  @media screen and (max-width: 320px) {\n    .mobile_cart_btn_group{\n        width: 54.5%;\n    }\n    .mobile_cart_btn{\n        width: 1.9rem;\n    }\n  }\n\n  .cart_products{\n    border-bottom: 1px solid #dddddd;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .mobile_cart_product_name{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
